@if(text())
{
    <div [ngClass]="optionsValue().cssClasses.wrapperContainer">
        @if(!optionsValue().template)
        {
            <span [ngClass]="optionsValue().cssClasses.textElement">{{text() | localize}}</span>
        }
        @else
        {
            <ng-container *ngTemplateOutlet="optionsValue().template"></ng-container>
        }
    </div>
}